import React from 'react';

import { Button } from '../../../../GlobalComponents/Button';
import { ButtonContainer } from '../../../../GlobalComponents/Form';

import { ModalContent, ModalTitle } from '../components/Card';

interface IAddBalanceProps {
	toggleHandler: () => void;
	buttonText: string;
}

const BalanceError: React.FC<IAddBalanceProps> = ({
	toggleHandler,
	buttonText
}: IAddBalanceProps) => {
	return (
		<ModalContent>
			<ModalTitle>Oh no!</ModalTitle>
			<p>
				We could not add to your balance! Please try again later. <br />
				Your card was not charged
			</p>
			<p>
				If this issue continues to happen, please
				<br /> let us know at{' '}
				<a href="mailto:feedback@biggby.com">feedback@biggby.com</a>
			</p>
			<ButtonContainer>
				<Button
					type="button"
					$backgroundColor="#F47920"
					$buttonSize={'small'}
					onClick={() => toggleHandler()}
				>
					{buttonText}
				</Button>
			</ButtonContainer>
		</ModalContent>
	);
};

export default BalanceError;
